function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pen_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.025 13.058L13.432 1.643a.624.624 0 01.442-.185h.001c.166 0 .325.066.442.184l4.041 4.041a.625.625 0 010 .885L6.942 17.976l-4.917-4.918zM18.807 4.953l.41-.411A2.64 2.64 0 0020 2.667c0-.72-.28-1.39-.78-1.882-1.002-1.012-2.763-1.01-3.762-.002l-.411.411 3.76 3.759zM1.687 13.898l-1.659 5.29a.624.624 0 00.785.784l5.289-1.659-4.415-4.415zM5.808 7.323c.16 0 .32-.06.442-.183l4.035-4.035a.996.996 0 01.787-.28l.986-.987a2.254 2.254 0 00-2.657.383L5.366 6.256a.625.625 0 00.442 1.067z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pen_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPen;